import { useEffect, useRef } from "react";

export default function HeroSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="accueil"
      ref={sectionRef}
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat animate-hero-zoom"
          style={{
            backgroundImage:
              "url(https://storage.readdy-site.link/project_files/2f83d064-4368-49c5-aa2e-85e52f732183/8a10c6a6-0c1c-4bca-b631-41f0a9a1d1fe_image-hero.png?v=bcb80f6d907106e3ae22c88732633dfc)",
          }}
        ></div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      <div className="container mx-auto px-6 h-full flex items-center w-full relative z-10">
        <div className="w-full md:w-1/2 z-10">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight animate-on-scroll opacity-0 translate-y-6 transition-all duration-700">
            <span className="block text-primary-500">Créateur</span>
            <span className="block text-foreground-50">d'Expériences</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-foreground-50 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 delay-150">
            Orchestrés avec passion et précision
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 delay-300">
            <a
              href="#contact"
              className="bg-primary-500 text-background-50 font-semibold px-8 py-3 rounded-lg whitespace-nowrap hover:bg-primary-600 transition-all duration-300 text-center"
            >
              Nous contacter
            </a>
          </div>
          <p className="mt-12 md:mt-36 text-xl md:text-2xl text-primary-500 italic max-w-2xl opacity-80 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 delay-500">
            "Nous ne sommes pas des prestataires, nous sommes votre binôme
            <br />
            Nous mettons en œuvre votre projet comme s'il était le nôtre"
          </p>
        </div>
      </div>
      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
        .animate-hero-zoom {
          animation: heroZoom 10s ease-out forwards;
        }
        @keyframes heroZoom {
          0% {
            transform: scale(1.15);
          }
          100% {
            transform: scale(1);
          }
        }
      `}</style>
    </section>
  );
}